import i18n from '@/i18n'

export const posCols = [
  {
    key: 'name',
    label: i18n.tc('support.pointOfService.posTable.name'),
    width: '20%'
  },
  {
    key: 'address',
    label: i18n.tc('support.pointOfService.posTable.address'),
    width: '30%',
    colClass: 'custom-padding'
  },
  {
    key: 'winterWorkingTime',
    label: i18n.tc('support.pointOfService.posTable.winterWorkingTime'),
    width: '25%'
  },
  {
    key: 'summerWorkingTime',
    label: i18n.tc('support.pointOfService.posTable.summerWorkingTime'),
    width: '25%'
  }
]
